(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('SoggettoEsternoDetailController', SoggettoEsternoDetailController);

    SoggettoEsternoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SoggettoEsterno'];

    function SoggettoEsternoDetailController($scope, $rootScope, $stateParams, previousState, entity, SoggettoEsterno) {
        var vm = this;

        vm.soggettoEsterno = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('gestioneAttiApp:soggettoEsternoUpdate', function(event, result) {
            vm.soggettoEsterno = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
